import { loadTextTranslations } from '../../js/translator.js';
import { appState } from '../../js/state.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { buildComponentPreFooterLinks } from './pre-footer-links.js';

// Import only this component's CSS
/*import "./main-footer.css";*/

export async function buildComponentMainFooter() {
  //const lang = appState.SiteLanguageCookie;
  console.log(
    `🔄 Building Component: buildComponentMainFooter - lang: ${appState.SiteLanguageCookie}`
  );

  try {


    


      await _initTranslatorTools();

    // 3) Dynamically import pre-footer links component
    const { buildComponentPreFooterLinks } = await import(
      /* webpackChunkName: "pre-footer-links" */
      './pre-footer-links.js'
    );

    // Build the pre-footer links dynamically
    const resultPreFooterLink = await buildComponentPreFooterLinks();

    // Build the footer HTML
    const html =
      resultPreFooterLink +
      `
            <div id="MainFooter" class="MainFooterWrapper">
                <div class="LastFooter">
                    <div class="LastFooter-socials">
                        <a href="https://www.facebook.com/Towobo.Global.Marketplace/" target="_blank">
                            <img src="https://my-towobo-cdn-endpoint-bzcbcgdphpaaf5eg.z02.azurefd.net/towobo-images-blob-main/wwwroot/imgs/icons/svg/facebook.svg" 
                                 width="20" height="20" class="svg-Image-SocialMediaIcons" alt="Towobo Facebook Page" loading="lazy" />
                        </a>
                        <a href="https://twitter.com/Towobo_Market" target="_blank">
                            <img src="https://my-towobo-cdn-endpoint-bzcbcgdphpaaf5eg.z02.azurefd.net/towobo-images-blob-main/wwwroot/imgs/icons/svg/twitter.svg" 
                                 width="20" height="20" class="svg-Image-SocialMediaIcons" alt="Towobo Twitter or X Page" loading="lazy" />
                        </a>
                        <a href="https://www.instagram.com/towobo_global_marketplace/" target="_blank">
                            <img src="https://my-towobo-cdn-endpoint-bzcbcgdphpaaf5eg.z02.azurefd.net/towobo-images-blob-main/wwwroot/imgs/icons/svg/instagram.svg" 
                                 width="20" height="20" class="svg-Image-SocialMediaIcons" alt="Towobo Instagram Page" loading="lazy" />
                        </a>
                        <a href="https://www.linkedin.com/in/towobo-global-marketplace/" target="_blank">
                            <img src="https://my-towobo-cdn-endpoint-bzcbcgdphpaaf5eg.z02.azurefd.net/towobo-images-blob-main/wwwroot/imgs/icons/svg/linkedin.svg" 
                                 width="20" height="20" class="svg-Image-SocialMediaIcons" alt="Towobo LinkedIn Page" loading="lazy" />
                        </a>
                    </div>

                    <div class="FooterTermsAndConditions">
                        <div class="FooterTermsAndConditions-TermsLinksWrapper">
                            <a href="${_tLinks.keyTermsAndConditions}" title="${_tTexts.keyTermsAndConditions}">
                                <span>${_tTexts.keyTermsAndConditions}</span>
                            </a>
                            <a href="${_tLinks.keyPrivacyPolicy}" title="${_tTexts.keySecurityNPrivacyPolicy}">
                                <span>${_tTexts.keySecurityNPrivacyPolicy}</span>
                            </a>
                            <a href="${_tLinks.keyCookiesPolicy}" title="${_tTexts.keyCookiesPolicy}">
                                <span>${_tTexts.keyCookiesPolicy}</span>
                            </a>
                            <a href="${_tLinks.keyAccessibilityStatement}" title="${_tTexts.keyAccessibilityStatement}">
                                <span>${_tTexts.keyAccessibilityStatement}</span>
                            </a>
                        </div>
                        <div class="FooterTermsAndConditions-CompanyTextWrapper">
                            © 2025 ${_tTexts.keyTowoboLimited} (${_tTexts.keyUnitedKingdom})
                        </div>
                    </div>
                </div>

                <div id="updatePanelGDPR"></div>
            </div>
        `;

    return html;
  } catch (err) {
    console.error('❌ Error building the main footer:', err);
    return '<div>Footer could not be loaded.</div>';
  }
}




let _tTexts;
let _tLinks;


async function _initTranslatorTools() {
  

    //if (!_tTexts || !_tLinks) {
        const { loadMyTranslationsService } = await import(
            /* webpackChunkName: "translation-service" */
            /* webpackPrefetch: true */
            '../../services/my-translator-service.js'
        );
        ({
            _tempTextTranslator: _tTexts,
            _tempLinksTranslator: _tLinks,
        } = await loadMyTranslationsService(
            appState.SiteLanguageCookie
        ));
   // }



}



export async function initComponentMainFooter() {}
